module.exports = __webpack_public_path__ + "img/articleDevenirParent1.4b41da34.png";